import axios from 'axios'

export default {
  state: {
    favorites: [],
  },
  getters: {
    Favorites(state) {
      return state.favorites
    },
  },
  mutations: {
    updateFavorites(state, favorites) {
      state.favorites = favorites
    },
  },
  actions: {
    fetchFavorites(ctx, type) {
      let q = type ? `?type=${type}` : ''
      return axios({
        method: 'GET',
        url: `api/user/favorites${q}`,
      })
        .then((response) => {
          ctx.dispatch('clearFavorites')
          ctx.commit('updateFavorites', response.data)
          return true
        })
        .catch((error) => {
          console.error(error)
          return false
        })
    },
    clearFavorites(ctx) {
      ctx.commit('updateFavorites', [])
    },
  },
}
